import { ReactElement } from 'react';
import { CELL_CLASS_NAMES } from '@client/cart/components/Cart';
import { useTranslate } from '@client/i18n/hooks';
import { Checkbox } from '@lib/components/Form/Checkbox/Checkbox';
import classNames from 'classnames';
import { useMultipleSelection } from 'b2b-components/hooks/useMultipleSelection';
import { Props } from './';
import './Header.scss';

export const CART_HEADER_TITLE_CLASS_NAME = 'CartHeader-Title';

export const Header = ({
  skus,
  isSelectable = false,
  selectedSkus = [],
  onCheckboxCheck,
  hasActionsHeader,
  className,
}: Props): ReactElement => {
  const t = useTranslate();
  const { isCheckboxChecked, onCheckboxChange } = useMultipleSelection(
    skus,
    selectedSkus,
    onCheckboxCheck,
    isSelectable,
  );

  return (
    <li className={classNames('CartHeader', className)}>
      {isSelectable && (
        <div className={classNames(CART_HEADER_TITLE_CLASS_NAME, CELL_CLASS_NAMES.select)}>
          <Checkbox
            isChecked={isCheckboxChecked}
            onChange={onCheckboxChange}
          />
        </div>
      )}

      <div className={classNames(CART_HEADER_TITLE_CLASS_NAME, CELL_CLASS_NAMES.thumbnail)} />

      <div className={classNames(CART_HEADER_TITLE_CLASS_NAME, CELL_CLASS_NAMES.title)}>{t('Article')}</div>

      <div className={classNames(CART_HEADER_TITLE_CLASS_NAME, CELL_CLASS_NAMES.stock)}>{t('Stock')}</div>

      <div className={classNames(CART_HEADER_TITLE_CLASS_NAME, CELL_CLASS_NAMES.price)}>
        <span dangerouslySetInnerHTML={{ __html: t('Price<br />(excl. VAT)') }} />
      </div>

      <div className={classNames(CART_HEADER_TITLE_CLASS_NAME, CELL_CLASS_NAMES.quantity)}>{t('Quantity')}</div>

      <div className={classNames(CART_HEADER_TITLE_CLASS_NAME, CELL_CLASS_NAMES.total)}>
        <span dangerouslySetInnerHTML={{ __html: t('Sum<br />(excl. VAT)') }} />
      </div>

      {hasActionsHeader && <div className={classNames(CART_HEADER_TITLE_CLASS_NAME, CELL_CLASS_NAMES.actions)} />}
    </li>
  );
};
